var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vx-card", [
    _c("div", { staticClass: "header-block" }, [
      _c("h4", [_vm._v("Histórico de consentimento")]),
      _c("p", [
        _vm._v(
          " É o que se apresenta numa fiscalização: quem aceitou o quê, em qual versão do documento e quando. A tabela é "
        ),
        _c("strong", [_vm._v("append-only")]),
        _vm._v(
          " — revogar cria uma linha nova, nada é reescrito (LGPD, Art. 8º, §2º). "
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "filters-row" },
      [
        _c("vs-input", {
          staticClass: "filter-field",
          attrs: {
            label: "E-mail do titular",
            placeholder: "Buscar por e-mail",
          },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.load.apply(null, arguments)
            },
          },
          model: {
            value: _vm.filters.email,
            callback: function ($$v) {
              _vm.$set(_vm.filters, "email", $$v)
            },
            expression: "filters.email",
          },
        }),
        _c(
          "vs-select",
          {
            staticClass: "filter-field",
            attrs: { label: "Finalidade" },
            on: { input: _vm.load },
            model: {
              value: _vm.filters.purpose,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "purpose", $$v)
              },
              expression: "filters.purpose",
            },
          },
          [
            _c("vs-select-item", { attrs: { value: "", text: "Todas" } }),
            _vm._l(_vm.purposeLabels, function (label, key) {
              return _c("vs-select-item", {
                key: key,
                attrs: { value: key, text: label },
              })
            }),
          ],
          2
        ),
        _c("vs-button", { attrs: { size: "small" }, on: { click: _vm.load } }, [
          _vm._v("Filtrar"),
        ]),
      ],
      1
    ),
    _vm.loading
      ? _c("div", { staticClass: "state-message" }, [_vm._v("Carregando…")])
      : !_vm.rows.length
      ? _c("div", { staticClass: "state-message" }, [
          _vm._v("Nenhum registro com estes filtros."),
        ])
      : _c("table", { staticClass: "privacy-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("Titular")]),
              _c("th", [_vm._v("Finalidade")]),
              _c("th", [_vm._v("Situação")]),
              _c("th", [_vm._v("Versão")]),
              _c("th", [_vm._v("Origem")]),
              _c("th", [_vm._v("Quando")]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.rows, function (row) {
              return _c("tr", { key: row.id }, [
                _c("td", [
                  _c("div", { staticClass: "subject" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          row.user
                            ? row.user.name
                            : "Visitante não identificado"
                        )
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(row.user ? row.user.email : row.visitor_id)
                      ),
                    ]),
                  ]),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm.purposeLabels[row.purpose] || row.purpose)),
                ]),
                _c("td", [
                  _c(
                    "span",
                    {
                      staticClass: "pill",
                      class: row.granted ? "granted" : "revoked",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(row.granted ? "Concedido" : "Revogado") +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c("td", [_vm._v(_vm._s(row.version || "—"))]),
                _c("td", { staticClass: "source-cell" }, [
                  _vm._v(_vm._s(row.source || "—")),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.formatDateTime(row.created_at)))]),
              ])
            }),
            0
          ),
        ]),
    _vm.pagination.last_page > 1
      ? _c(
          "div",
          { staticClass: "pagination-row" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  size: "small",
                  type: "border",
                  disabled: _vm.page <= 1,
                },
                on: {
                  click: function ($event) {
                    return _vm.go(_vm.page - 1)
                  },
                },
              },
              [_vm._v("Anterior")]
            ),
            _c("span", [
              _vm._v(
                "Página " +
                  _vm._s(_vm.pagination.current_page) +
                  " de " +
                  _vm._s(_vm.pagination.last_page)
              ),
            ]),
            _c(
              "vs-button",
              {
                attrs: {
                  size: "small",
                  type: "border",
                  disabled: _vm.page >= _vm.pagination.last_page,
                },
                on: {
                  click: function ($event) {
                    return _vm.go(_vm.page + 1)
                  },
                },
              },
              [_vm._v("Próxima")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }